




import { CartHeaderView, selectCartHeader } from '@spa/components/organisms/header/cart/select-cart-header'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { InstanceResolver } from '@/util/instanceResolver'
import { InfoService } from '@spa/services/api/info'

@Component
export default class CartHeader extends Vue {
  @Prop()
  title: string

  versioning: string | null = null

  shouldDisplayVersioning: boolean = false

  async created() {
    // TODO: Use Vuex store
    const result = await InfoService.versioning()

    if (result.isLeft()) {
      return
    }

    this.versioning = _.get(result.value, 'fullText')
    this.shouldDisplayVersioning = _.get(result.value, 'display')
  }

  get cartHeaderParts(): CartHeaderView {
    return selectCartHeader({ title: this.title, instance: InstanceResolver })
  }
}
